import { oz } from '@weft/utils';
import { CriterionOperatorSchema } from './criterion-operator-schema';

export const CriterionSchema = oz.object({
  field: oz.string().nonempty(),
  operator: CriterionOperatorSchema,
  value: oz.string().nonempty(),
}).openapi('Criterion');

export type Criterion = oz.infer<typeof CriterionSchema>;